type FillInGapExerciseIdentity = {
  content: string;
  correctAnswer: string;
  languageCode?: string;
};

const GAP_PATTERN = /_{3,}/g;
export const MAX_RECENT_EXERCISES = 50;
export const MAX_RECENT_EXERCISE_LENGTH = 400;

export function countFillInGapBlanks(sentence: string): number {
  return sentence.match(GAP_PATTERN)?.length ?? 0;
}

export function hasExactlyOneFillInGapBlank(sentence: string): boolean {
  return countFillInGapBlanks(sentence) === 1;
}

function normalizeFingerprintPart(value: string): string {
  return value.trim().toLocaleLowerCase().replace(/\s+/g, " ");
}

export function createFillInGapSentenceFingerprint(sentence: string): string {
  return sentence
    .normalize("NFKC")
    .toLocaleLowerCase()
    .replace(/_{3,}/g, " ____ ")
    .replace(/[^\p{L}\p{N}_\s]/gu, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function createFillInGapExerciseFingerprint(exercise: FillInGapExerciseIdentity): string {
  return [exercise.languageCode || "", exercise.content, exercise.correctAnswer]
    .map(normalizeFingerprintPart)
    .join("|");
}
